(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mk-giveaway"]) return;
  try {
    
(()=>{
  const sessionKey='mk-giveaway-november-2026-dismissed';
  function init(root=document){
    root.querySelectorAll('[data-mk-giveaway]').forEach(section=>{
      const main=document.querySelector('#MainContent');
      if(!main)return;
      const candidates=[...main.querySelectorAll('section,.mkc-delivery-band')].filter(el=>!section.contains(el)&&el!==section&&el.compareDocumentPosition(section)&Node.DOCUMENT_POSITION_FOLLOWING);
      let previous=candidates.pop();
      while(previous){
        const bg=getComputedStyle(previous).backgroundColor;
        const rgb=bg.match(/[\d.]+/g);
        if(rgb&&rgb.length>=3&&(rgb.length<4||Number(rgb[3])>.5)){
          const brightness=.2126*Number(rgb[0])+.7152*Number(rgb[1])+.0722*Number(rgb[2]);
          section.classList.toggle('mk-giveaway--dark',brightness>145);
          section.classList.toggle('mk-giveaway--light',brightness<=145);
          break;
        }
        previous=previous.parentElement;
      }
    });
    root.querySelectorAll('[data-mk-giveaway-dialog]').forEach(dialog=>{
      if(dialog.dataset.ready)return;
      dialog.dataset.ready='true';
      let priorOverflow='';
      function close(){if(dialog.open)dialog.close();}
      dialog.querySelector('[data-mk-giveaway-close]').addEventListener('click',close);
      dialog.addEventListener('click',event=>{if(event.target===dialog)close();});
      dialog.addEventListener('close',()=>{document.documentElement.style.overflow=priorOverflow;try{sessionStorage.setItem(sessionKey,'1');}catch(e){}});
      if(window.Shopify&&Shopify.designMode)return;
      try{if(sessionStorage.getItem(sessionKey))return;}catch(e){}
      const open=()=>setTimeout(()=>{
        if(!dialog.isConnected||typeof dialog.showModal!=='function'||document.querySelector('dialog[open]'))return;
        const img=dialog.querySelector('img');
        img.src=img.dataset.posterSrc;
        const show=()=>{if(!dialog.isConnected||dialog.open)return;priorOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden';};
        if(img.complete&&img.naturalWidth)show();else img.addEventListener('load',show,{once:true});
      },700);
      if(document.readyState==='complete')open();else window.addEventListener('load',open,{once:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
